// The trip views carry the plan as its display label (planLabel in ./pricing): read the rate back
// for the summary line "8 min × 0,21 €" (Figma 08) and the pause reminder (P2).

const RATE_RE = /(\d+,\d{2} €) \/ (?:(\d+) )?min/;

/** Rate part of a plan label: "0,21 € / min" (with its per-minute amount) or "1,50 € / 20 min". */
export function rateOf(label: string): { text: string; perMinute?: string } | undefined {
  const m = RATE_RE.exec(label);
  if (!m) return undefined;
  const [text, amount, interval] = m as unknown as [string, string, string | undefined];
  return interval === undefined || interval === "1" ? { text, perMinute: amount } : { text };
}

/** Billed time line of the summary: "8 min × 0,21 €", else "8 min · <rate or label>". */
export function billedLine(minutes: number, label: string): string {
  const rate = rateOf(label);
  if (rate?.perMinute) return `${minutes} min × ${rate.perMinute}`;
  const rest = rate?.text ?? label;
  return rest ? `${minutes} min · ${rest}` : `${minutes} min`;
}
